import { createSelector } from 'reselect';
import { RecordOf } from 'immutable';
import { RootState } from 'store';

const selectHierarchyState = () => (state: RecordOf<RootState>) => state.get('hierarchy');

export const selectHierarchy = () => createSelector(selectHierarchyState(), (substate) => substate.get('hierarchy'));

export const selectHierarchyValues = () => createSelector(selectHierarchy(), (hierarchy) => hierarchy.values);

export const selectHierarchyLoading = () => createSelector(selectHierarchy(), (hierarchy) => hierarchy.loading);

export const selectSelectedHierarchyEntity = () =>
  createSelector(selectHierarchyState(), (substate) => substate.get('selectedEntity'));
